import { FormFieldOption } from "../../../../../../shared/form/fields/types";
import React from "react";
import { CouponCodeFormFieldsName, HaveCouponCodeOptionValue } from "../../enum";
import * as Yup from "yup";
import Validation from "../../../../../../shared/form/Validation";
import { useCopies } from "../../../../../../shared/hooks/useCopies";
import { HaveCouponCodeFormArgsType } from "../../type";
import { useValidateCouponCode } from "../../dataloader";

export default function useCouponCodeFormService({
  couponCodeFormValues,
  successHandler,
  state,
  dispatcher
}: HaveCouponCodeFormArgsType) {
  const copies = useCopies();
  const formRef = React.useRef<any>();
  const { mutateAsync: validateCouponCode } = useValidateCouponCode();
  const haveCouponCodeOptions: Array<FormFieldOption> = React.useMemo(() => {
    return [
      { value: HaveCouponCodeOptionValue.YES, label: copies.get("yes") },
      { value: HaveCouponCodeOptionValue.NO, label: copies.get("no") }
    ];
  }, [copies]);

  const initialValues = React.useMemo(() => {
    return {
      [CouponCodeFormFieldsName.HAVE_COUPON_CODE]:
        couponCodeFormValues?.[CouponCodeFormFieldsName.HAVE_COUPON_CODE] || "",
      [CouponCodeFormFieldsName.COUPON_CODE]: couponCodeFormValues?.[CouponCodeFormFieldsName.COUPON_CODE] || ""
    };
  }, [couponCodeFormValues]);

  const submitHandler = React.useCallback(
    async values => {
      const couponCode = values[CouponCodeFormFieldsName.COUPON_CODE];
      try {
        const responseData = await validateCouponCode({
          params: { couponCode, registrationFormId: state.participantData?.registrationForm?.id }
        });
        successHandler({
          couponCodeFormValues: values,
          applicableRateCardDetails: responseData
        });
      } catch (e) {
        dispatcher.updateCouponCodeFormValues({
          [CouponCodeFormFieldsName.COUPON_CODE]: "",
          [CouponCodeFormFieldsName.HAVE_COUPON_CODE]: HaveCouponCodeOptionValue.YES
        });
      }
    },
    [successHandler, validateCouponCode, state.participantData?.registrationForm?.id, dispatcher]
  );

  const validationSchema = React.useMemo(() => {
    return Yup.object().shape({
      [CouponCodeFormFieldsName.HAVE_COUPON_CODE]: Validation.yupIsReq({
        required: true,
        copies: copies
      }),
      [CouponCodeFormFieldsName.COUPON_CODE]: Validation.textFieldValidation({
        required: true,
        copies: copies
      })
    });
  }, [copies]);

  const haveCouponCodeChangeHandler = React.useCallback(
    value => {
      if (value === HaveCouponCodeOptionValue.NO) {
        successHandler({
          couponCodeFormValues: { [CouponCodeFormFieldsName.HAVE_COUPON_CODE]: value }
        });
      }
    },
    [successHandler]
  );

  return {
    haveCouponCodeOptions,
    initialValues,
    submitHandler,
    validationSchema,
    haveCouponCodeChangeHandler,
    formRef
  };
}
